const albumsTitles = [
  {
    id: 1,
    album_id: 1,
    title: "20 Min",
    artist: "Lil Uzi Vert",
    audio_src: "https://utfs.io/f/YPK6Os4Irq6ToATPLoDh4O3jSi95J0zbFPdRUvqgZG7Qucxy",
    duration: "03:41",
  },
  {
    id: 12,
    album_id: 1,
    title: "XO Tour Llif3",
    artist: "Lil Uzi Vert",
    audio_src: "https://z0cpgg13oz.ufs.sh/f/YPK6Os4Irq6TdugkMESOq1XPEw67U4YT8Qpnb5axWZeKNgAR",
    duration: "03:41",
  },
  {
    id: 3,
    album_id: 2,
    title: "Like That",
    artist: "Metro Boomin",
    audio_src: "https://utfs.io/f/YPK6Os4Irq6T8QMUXfvUwcuthBLpYIA2XydS7oaMCqRgKFbl",
    duration: "04:29",
  },
  {
    id: 3,
    album_id: 3,
    title: "Unstoppable",
    artist: "Sia",
    audio_src: "https://utfs.io/f/YPK6Os4Irq6Tykl4dlj2W98eN4mHz0VkPwXo5iEUbvtl7MBa",
    duration: "03:46",
  },
  {
    id: 4,
    album_id: 4,
    title: "COLTELLINO",
    artist: "Elgrandetoto",
    audio_src: "https://utfs.io/f/YPK6Os4Irq6Ty582MLj2W98eN4mHz0VkPwXo5iEUbvtl7MBa",
    duration: "03:06",
  },
];

const getTitlesByAlbumId = (albumId) => {
  return albumsTitles.filter((title) => title.album_id === albumId);
};

export { getTitlesByAlbumId };